<template>
    <div class="boleto-payment-form">
        <form @submit.prevent="submit($event)" id="boleto-form" class="row m-0 p-0 mb-2">
            <div class="col-md-8 px-0 d-flex justify-content-between gap-2">
                <select 
                    data-vv-as="boleto-installments" 
                    :class="{'input': true, 'is-invalid': errors.has('boleto-installments') }"
                    name="boleto-installments" 
                    v-validate="'required'"
                    type="text"
                    class="form-select"
                    v-model="selected"
                    id="boleto-installments"
                    placeholder="Parcelas"
                >
                    <option value="0" disabled selected> {{ $t('Opções de parcelamento') }} </option>
                    <option :value="item.number" v-for="(item, index) in installments" :key="item.number">
                        <span v-if="index == 0 || item.cards == 0">
                            {{item.number}}x  {{ $t('de') + ' ' + $n(item.numerical_value + item.cards, 'currency', locale) }}
                        </span>
                        <span v-else>
                            1x  {{ $t('de') + ' ' + $n(item.numerical_value + item.cards, 'currency', locale) }} e {{item.number - 1}}x  {{ $t('de') + ' ' + $n(item.numerical_value, 'currency', locale) }}
                        </span>
                    </option>
                </select>

                <select
                    v-if="clientsWithDueDateSelection && selected !== 1"
                    data-vv-as="boleto-due-date" 
                    :class="{'input': true, 'is-invalid': errors.has('boleto-due-date') }"
                    name="boleto-due-date" 
                    v-validate="'required'"
                    type="text"
                    class="form-select"
                    v-model="dueDate"
                    id="boleto-due-date"
                    placeholder="Dia de vencimento"
                >
                    <option value="0" disabled selected> {{ $t('Opções de vencimento') }} </option>
                    <option :value="day" v-for="day in monthDays" :key="day">
                        <span>
                            Vencimento dia {{ day }}
                        </span>
                    </option>
                </select>
                <div class="invalid-feedback">
                    @{{ errors.first('boleto-due-date') }}
                </div>
            </div>
            <div class="col-md-2 col-6 mt-md-0 mt-2 px-0 ps-md-2 pe-2">
                <button v-if="!loading" class="form-control btn btn-dark" type="button" @click="cancel"> Voltar </button>
            </div>
            <div v-if="!loading" class="col-md-2 col-6 mt-md-0 mt-2 px-0 ps-2">
                <button class="form-control btn btn-primary text-light" type="submit" :disabled="finished"> Pagar </button>
            </div>
            <div v-else class="col-md-2 col-12 mt-md-0 mt-2 px-0 ps-md-2">
                <button class="form-control btn btn-primary d-flex justify-content-center align-items-center" type="button" disabled>
                    <div style="width: 1.3rem; height: 1.3rem;" class="spinner-border text-light" role="status"></div>
                    <div class="sr-only">Carregando</div>
                </button>
            </div>
        </form>
        <div v-if="fee" class="alert alert-info mb-2">
            <i class="fas fa-info me-2"></i> 
            Acréscimo de {{ fee.valor_parametro | currency }} em cada parcela, referente a taxa de serviços de emissão e compensação de boletos.
        </div>
        <div class="alert alert-warning mb-0">
            <i class="fas fa-warning me-2"></i> 
            A compensação de um pagamento via boleto bancário pode demorar até 72 horas após o pagamento. Sua conta só será ativada após esse processamento ocorrer.
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            selected: 1,
            finished: false,
            dueDate: null,
            monthDays: [],
        }
    },
    created() {
        this.setupDueDate()
    },
    props: {
        cart: {
            required: true,
            type: Object,
        },
        products: {
            required: true,
            type: Array,
        },
        installments: {
            required: true,
            type: Array,
        },
        loading: {
            default: false,
            type: Boolean
        },
        rules: {
            type: Array,
        },
        member: {
            default: null,
            type: Object,
        },
    },
    methods: {
        async submit($event) {
            $event.preventDefault()
            $event.stopPropagation()

            try {
                this.loading = true
                
                const token = await window.generateRecaptchaToken();

                const response = await axios.post('/api/payment/sign', {
                    cart: this.cart,
                    products: this.products,
                    card: {
                        installments: this.selected,
                        due_date: this.dueDate,
                    },
                    type: 'boleto',
                    token: token
                });
                
                this.finished = true

                this.$emit('submit', response.data.order)
            } catch (error) {
                console.log(error)
                this.$emit('error', error.response.data.message ?? error.response.data.error)
            }
        },
        cancel() {
            this.$emit('close')
        },
        format(value) {
            const formatter = new Intl.NumberFormat(
                window.i18n.locale.replace('_', '-'), 
                { 
                    style: 'currency', 
                    currency: 'BRL' 
                }
            )
            return formatter.format(value)
        },
        setupDueDate() {
            if (!this.clientsWithDueDateSelection) return;

            for (let day = 1; day <= 28; day++) {
                this.monthDays.push(day)
            }

            const date = new Date().getDate()
            this.dueDate = date > 28 ? 28 : date 
        },
    },
    computed: {
        fee() {
            const rules = this.rules.filter((i) => i.nome == 'taxa_bol_socio')

            if (!rules) return false

            return rules[0]
        },
        locale() {
            return window.locale.replace('_', '-')
        },
        clientsWithDueDateSelection() {
            const clients = [14, 1001]

            return clients.includes(Number(this.member.id_clube))
        },
    },
})
</script>
